<template>
  <div class="row">
    <div class="col-12">
      <div class="mt-3">
        <div class="card border-top border-0 shadow-sm">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mb-3">
                <h5 class="fw-bold text-black-50 mb-3">Profile Details</h5>
                <div class="d-flex">
                  <div class="me-3">
                    <img src="../../assets/user_images/1.jpeg" alt="" class="user-image">
                  </div>
                  <div class="">
                    <button class="btn btn-outline-primary" id="image-uploader">
                      <i class="fa-solid  fa-images"></i>
                      Change New Profile
                    </button>
                    <small class="mb-0 mt-3 d-block text-black-50">Allowed JPG, GIF or PNG. Max size of 800K</small>
                  </div>
                </div>
              </div>
              <hr>
              <div class="col-12 col-md-6">
                <div class="">
                  <p class="fw-bold text-black-50 mb-3">
                    <i class="fa-solid fa-circle-info text-primary"></i>
                    Profile Info
                  </p>
                  <form action="" class="">
                    <FloatingInput label="Name" icon="fa-solid fa-user-alt" title="Enter Your Name" type="text"></FloatingInput>
                    <FloatingInput label="Email" icon="fa-solid fa-envelope" title="Enter Your Email" type="email"></FloatingInput>
                    <FloatingInput label="Phone Number" icon="fa-solid fa-phone" title="Enter Your Phone Number" type="text"></FloatingInput>
                    <FloatingInput label="Location" icon="fa-solid fa-location-arrow" title="Enter Your Location" type="text"></FloatingInput>
                    <div class="">
                      <button class="btn btn-outline-primary me-3">Save Changes</button>
                      <button class="btn btn-outline-secondary">Cancel</button>
                    </div>
                  </form>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="">
                  <p class="fw-bold text-black-50 mb-3">
                    <i class="fa-solid fa-key text-primary"></i>
                    Change Password
                  </p>
                  <form action="" class="">
                    <FloatingInput label="Old Password" icon="fa-solid fa-key" title="Enter Your Location" type="text"></FloatingInput>
                    <FloatingInput label="New Password" icon="fa-solid fa-lock" title="Enter Your Location" type="text"></FloatingInput>
                    <FloatingInput label="Confirm Password" icon="fa-solid fa-lock-open" title="Enter Your Location" type="text"></FloatingInput>
                  </form>
                  <div class="d-flex justify-content-end">
                    <button class="btn btn-outline-success me-3">Change Password</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card rounded border-top border-0 shadow-sm my-3">
          <div class="card-body">
            <p class="fw-bold text-black-50 mb-3">
              <i class="fa-solid fa-circle-exclamation text-danger"></i>
              Delete Account
            </p>
            <div class="alert alert-warning">
              <h6 class="alert-heading fw-bold mb-1">Are you sure you want to delete your account?</h6>
              <p class="mb-0">Once you delete your account, there is no going back. Please be certain.</p>
            </div>
            <form id="formAccountDeactivation" onsubmit="return false">
              <div class="form-check mb-3">
                <input
                    class="form-check-input"
                    type="checkbox"
                    name="accountActivation"
                    id="accountActivation"
                />
                <label class="form-check-label" for="accountActivation"
                >I confirm my account deactivation</label
                >
              </div>
              <button type="submit" class="btn btn-danger deactivate-account">Deactivate Account</button>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import FloatingInput from "@/components/form/FloatingInput";
export default {
  name: "AccountView",
  components: {FloatingInput}
}
</script>

<style scoped>
.user-image{
  width: 150px;
  height: 150px;
  border-radius: 10px;
  object-fit: cover;
}
</style>